import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ref, get, child } from "firebase/database";
import { database } from "../../config/firebaseConfig"; // adjust this import if your db export is elsewhere
// import pipeSpecsData from '../data/pipeSpecs.json';

// Initial state includes a local fallback (pipeSpecsData) as well as status and error tracking
const initialState = {
  specs: [],
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

/**
 * Async thunk to load pipe specifications from Firebase.
 * It looks under the `/engineering/pipeSpecs` node; if nothing is found or Firebase
 * isn’t configured, it falls back to the bundled JSON data.
 */
export const fetchPipeSpecsAsync = createAsyncThunk(
  "pipeSpecs/fetchPipeSpecs",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      // If Firebase isn’t available, use local data
      if (!database) {
        return [];
      }

      const snapshot = await database
        .ref("engineering/pipeSpecs")
        .once("value");
      // if (snapshot && snapshot.exists()) {
      //   return dispatch(setPipeSpecs(snapshot.val()));
      // }
      // fall back to local data if the path doesn’t exist
      return snapshot.exists() ? snapshot.val() : [];
    } catch (error) {
      console.error("Error fetching pipe specs:", error);
      return rejectWithValue(error.message);
    }
  }
);

const pipeSpecsSlice = createSlice({
  name: "pipeSpecs",
  initialState,
  reducers: {
    // still allow manual overriding of specs if needed
    setPipeSpecs(state, action) {
      state.specs = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPipeSpecsAsync.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPipeSpecsAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.specs = action.payload;
      })
      .addCase(fetchPipeSpecsAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to load pipe specs";
      });
  },
});

// Selectors to get data from the store
export const selectPipeSpecs = (state) => state.pipeSpecs.specs;
export const selectPipeSpecByNps = (state, nps) =>
  state.pipeSpecs.specs.find(
    (spec) => spec.nps.toLowerCase() === nps.toLowerCase()
  );

export const { setPipeSpecs } = pipeSpecsSlice.actions;

export default pipeSpecsSlice.reducer;
